import { render, staticRenderFns } from "./CategoryCardParent.vue?vue&type=template&id=ad0a3dae&scoped=true"
import script from "./CategoryCardParent.vue?vue&type=script&lang=ts"
export * from "./CategoryCardParent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad0a3dae",
  null
  
)

export default component.exports